<div class="m-4" *ngIf="eventNotFound">
  <h2>Occurrence not found</h2>
</div>

<div class="m-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="m-4" *ngIf="!eventNotFound && (serverError === null)">

  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label for="selectLocation">Location</label>
        <select class="custom-select"
                id="selectLocation" name="selectLocation"
                [(ngModel)]="event.location_id"
                [disabled]="loadingEvent || !isNewEvent"
                [class.disabled]="loadingEvent || !isNewEvent">
          <ng-container *ngIf="locations">
            <option *ngFor="let location of locations"
                    [ngValue]="location.id">
              {{ location.name }}
            </option>
          </ng-container>
        </select>
        <small *ngIf="eventType.has_limited_location_availability"
               class="form-text text-muted">
          This event type is restricted to specific locations.
        </small>
        <div class="form-text text-danger">{{ errors.location_id }}</div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group">
        <ng-container *ngIf="loadingEvent || loadingLocationAreas">
          <label>Area (optional)</label>
          <select class="custom-select" disabled>
            <option>Loading...</option>
          </select>
        </ng-container>
        <ng-container *ngIf="!(loadingEvent || loadingLocationAreas)">
          <label for="locationAreaSelect">
            Area (optional)
          </label>
          <div class="float-right">
            <a href="#"
               (click)="$event.preventDefault();loadLocationAreas();">
              Refresh Areas
            </a>
            |
            <a routerLink="/areas-config" target="_blank">
              Configure Areas
            </a>
          </div>
          <select class="custom-select" id="locationAreaSelect" name="gym_area_id"
                  [(ngModel)]="event.location_area_id">
            <option [ngValue]="null">No Area</option>
            <option *ngFor="let locationArea of getLocationAreasForLocation()" [ngValue]="locationArea.id">
              {{ locationArea.name }} (Capacity {{ locationArea.capacity }})
            </option>
          </select>
        </ng-container>
        <small class="form-text text-muted clearfix">
          Setting an area will cap capacity for the event once the area's capacity has been met. This is optional, and capacity may also be set per time slot.
        </small>
        <div class="form-text text-danger">{{ errors.location_area_id }}</div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label for="occurrenceNameInput">Staff Occurrence Name (optional)</label>
        <input type="text" class="form-control" name="occurrence_name" id="occurrenceNameInput"
               [(ngModel)]="event.occurrence_name">
        <small class="form-text text-muted">
          This is displayed on the Scheduled Events page after the event type name to help staff distinguish between occurrences of the same event type. It is not displayed to customers.
        </small>
        <div class="form-text text-danger">{{ errors.occurrence_name }}</div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group">
        <label for="customer_facing_name">Customer Occurrence Name (optional)</label>
        <input type="text" class="form-control" name="customer_facing_name" id="customer_facing_name"
               [(ngModel)]="event.customer_facing_name">
        <small class="form-text text-muted">
          This is displayed in the Climber App after the event type name to help customers distinguish between occurrences of the same event type.
        </small>
        <div class="form-text text-danger">{{ errors.customer_facing_name }}</div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <ng-container *ngIf="loadingEvent || loadingBenefitMemberships">
          <label>Benefit Membership (optional)</label>
          <select class="custom-select" disabled>
            <option>Loading...</option>
          </select>
        </ng-container>
        <ng-container *ngIf="!(loadingEvent || loadingBenefitMemberships)">
          <label for="benefit_membership_id">
            Benefit Membership (optional)
          </label>
          <div class="float-right">
            <a href="#"
               (click)="$event.preventDefault();loadBenefitMemberships();">
              Refresh Memberships
            </a>
            |
            <a routerLink="/memberships-and-passes" target="_blank">
              Configure Memberships
            </a>
          </div>
          <select class="custom-select"
                  id="benefit_membership_id"
                  name="benefit_membership_id"
                  [(ngModel)]="event.benefit_membership_id">
            <option [ngValue]="null">No Benefit Membership</option>
            <option *ngIf="benefitMembershipRetired(event.benefit_membership_id)"
                    [ngValue]="event.benefit_membership_id">
              {{ event.benefit_membership_name }} (Retired)
            </option>
            <option *ngFor="let membership of benefitMembershipList"
                    [ngValue]="membership.id">
              {{ membership.name }}
            </option>
          </select>
        </ng-container>
        <small class="form-text text-muted clearfix">
          Each participant booked onto this event receives the benefit membership from the beginning of the event's first day through the end of its last day, plus the additional days. Participants already booked receive it when the event is saved.
          <br>
          Only active memberships with Purchase Type "Benefit" may be selected.
        </small>
        <div class="form-text text-danger">{{ errors.benefit_membership_id }}</div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group">
        <label for="benefit_membership_additional_days">
          Benefit Additional Days After Event
        </label>
        <div class="input-group">
          <input type="number" class="form-control"
                 name="benefit_membership_additional_days"
                 id="benefit_membership_additional_days"
                 min="0" max="365" step="1"
                 [disabled]="event.benefit_membership_id === null"
                 [(ngModel)]="event.benefit_membership_additional_days">
          <div class="input-group-append">
            <span class="input-group-text">days</span>
          </div>
        </div>
        <small class="form-text text-muted">
          The number of additional days after the event's last day that the benefit membership should extend. For example, with 13 additional days, an event on 5 October grants the membership through the end of 18 October.
        </small>
        <div class="form-text text-danger">{{ errors.benefit_membership_additional_days }}</div>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col">
      <button class="btn btn-sm btn-primary" type="button"
              (click)="openQuickAddOccurrencesModal()">
        Quick Add Dates
      </button>
    </div>
  </div>

  <div class="row mt-3" *ngFor="let eventPart of event.event_parts; let idx = index;">

    <div class="col-4">
      <label>Date *</label>
      <app-date-picker [id]="'date' + idx.toString()"
                       [(content)]="eventPart.start_date"></app-date-picker>
    </div>
    <div class="col-3">
      <label>Start Time *</label>
      <input type="time" step="60"
             class="form-control"
             [name]="'startTime' + idx.toString()"
             [(ngModel)]="eventPart.start_time">
    </div>
    <div class="col-3">
      <label>Duration (minutes) *</label>
      <input type="number" class="form-control"
             min="1" max="1440" step="1"
             [name]="'duration_minutes' + idx.toString()"
             [(ngModel)]="eventPart.duration_minutes">
    </div>
    <div class="col-2">
      <label>&nbsp;</label>
      <button class="btn btn-outline-danger d-block"
              (click)="event.event_parts.splice(idx, 1)">
        Remove
      </button>
    </div>

    <div class="col-xl-6 col-lg-8 col-md-10 col-12 mt-2">
      <app-edit-event-instructors [instructors]="eventPart.instructors"
                                  [useIsSub]="true"
                                  [id]="'editInstructors' + idx.toString()"></app-edit-event-instructors>
    </div>

  </div>

  <div class="form-text text-danger">
    {{ errors.event_parts }}
  </div>

  <button class="btn btn-link pl-0 d-block mb-4" type="button"
          (click)="addNewEventPart()">
    Add Date
  </button>

  <div class="form-group">
    <label>How far in advance can someone book this event? *</label>
    <div class="row">
      <div class="col-lg-6 col-md-8">
        <div class="row">
          <div class="col-8">
            <input type="number" class="form-control" name="rollingDays"
                   min="1" max="366" step="1"
                   *ngIf="!event.rolling_days_use_exact_date"
                   [(ngModel)]="event.rolling_days">
            <app-date-picker *ngIf="event.rolling_days_use_exact_date"
                             [id]="'bookingOpenDate'"
                             [(content)]="bookingOpenDate"></app-date-picker>
          </div>
          <div class="col-4 pl-0">
            <select class="custom-select w-100"
                    [(ngModel)]="event.rolling_days_use_exact_date"
                    (ngModelChange)="handleRollingDaysUseExactDateChange()">
              <option [ngValue]="false">days</option>
              <option [ngValue]="true">exact date</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="form-text text-danger">
      {{ errors.rolling_days }}
    </div>
  </div>

  <div class="form-group">
    <label for="booking_open_time">
      At what time of day does booking open for this event?
    </label>
    <div class="row">
      <div class="col-6">
        <div class="input-group">
          <input type="time" class="form-control"
                 name="booking_open_time"
                 id="booking_open_time"
                 [(ngModel)]="event.booking_open_time">
        </div>
      </div>
    </div>
    <small class="form-text text-muted">
      Use this setting to determine at what time of day (in the location's local time) this event first becomes available for booking. The default, midnight ("00:00", or "12 AM"), is counted as the <i>start</i> of the day.
    </small>
    <div class="form-text text-danger">
      {{ errors.booking_open_time }}
    </div>
  </div>

  <div class="form-group">
    <label>Capacity *</label>
    <div class="row">
      <div class="col-6">
        <input type="number" class="form-control" name="capacity"
               min="1" max="1000" step="1"
               [(ngModel)]="event.capacity">
      </div>
    </div>
    <div class="form-text text-danger">
      {{ errors.capacity }}
    </div>
  </div>

  <div class="form-group">
    <label>Pricing Matrix</label>
    <div class="row">
      <div class="col-6">
        <select class="custom-select" name="pricing_matrix_id"
                [(ngModel)]="event.pricing_matrix_id">
          <option [ngValue]="null" class="text-muted">None</option>
          <option *ngFor="let pricingMatrix of pricingMatrices"
                  [ngValue]="pricingMatrix.id">
            {{ pricingMatrix.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-text text-danger">
      {{ errors.pricing_matrix_id }}
    </div>
  </div>

  <div class="form-group">
    <div class="row">
      <div class="col-sm-8 col-lg-6">
        <label for="tax_rate_id">Tax Rate</label>
        <div class="float-right">
          <a href="#"
             (click)="$event.preventDefault();loadTaxRates();">
            Refresh Tax Rates
          </a>
          |
          <a routerLink="/tax-rates-config" target="_blank">
            Configure Tax Rates
          </a>
        </div>
        <select class="custom-select"
                name="tax_rate_id" id="tax_rate_id"
                *ngIf="!loadingTaxRates"
                [(ngModel)]="event.tax_rate_id">
          <option [ngValue]="null">
            Event Type Default ({{ getEventTypeTaxRate() }})
          </option>
          <option *ngFor="let taxRate of taxRateList"
                  [ngValue]="taxRate.id">
            {{ taxRate.name }} - {{ taxRate.rate_percent }}%
          </option>
        </select>
        <select class="custom-select"
                *ngIf="loadingTaxRates" disabled>
          <option>Loading...</option>
        </select>
      </div>
    </div>
  </div>

  <div class="alert alert-danger" role="alert"
       *ngIf="errors.non_field_errors">
    {{ errors.non_field_errors }}
  </div>
  <div class="alert alert-danger" role="alert"
       *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <div class="alert alert-info" role="alert"
       *ngIf="loadingSave">
    Saving...
  </div>

  <button class="btn btn-primary float-right"
          [disabled]="isLoading()" [class.disabled]="isLoading()"
          (click)="save()">
    Save Occurrence
  </button>

  <a class="btn btn-secondary"
          [routerLink]="'/events/setup/edit/' + eventType?.id + '/schedules'">
    Cancel
  </a>

</div>
